/**
 * Spanish (es) mappings for AuthPromptModal
 */

export const authPromptModalES = {
  // Modal header
  "AUTHENTICATION REQUIRED": "AUTENTICACIÓN REQUERIDA",

  // Default messages
  "Sign in to continue": "Inicia sesión para continuar",
  "Create a free account to access this feature": "Crea una cuenta gratuita para acceder a esta función",

  // Feature-specific messages
  "Start chatting with AI": "Comienza a chatear con IA",
  "Sign in to get personalized sports insights and predictions": "Inicia sesión para obtener pronósticos y predicciones deportivas personalizadas",

  "View your history": "Ver tu historial",
  "Sign in to access your conversation history and saved predictions": "Inicia sesión para acceder a tu historial de conversaciones y predicciones guardadas",

  "Access live sports data": "Accede a datos deportivos en vivo",
  "Sign in to get real-time sports updates and analytics": "Inicia sesión para obtener actualizaciones deportivas y análisis en tiempo real",

  "Get AI predictions": "Obtén predicciones de IA",
  "Sign in to receive AI-powered game predictions and analysis": "Inicia sesión para recibir predicciones y análisis de juegos con IA",

  "Manage Star Coins": "Administrar Star Coins",
  "Sign in to view and use your Star Coins balance": "Inicia sesión para ver y usar tu saldo de Star Coins",

  "Sign in to Analyze Insights": "Inicia sesión para Analizar Pronósticos",
  "Join thousands of users getting AI-powered sports insights": "Únete a miles de usuarios obteniendo pronósticos deportivos con IA",

  // Buttons
  "Continue with Google": "Continuar con Google",
  "Already have an account? Sign in": "¿Ya tienes una cuenta? Inicia sesión",

  // Divider
  "or": "o",

  // Security
  "Secured by Google": "Protegido por Google",

  // Benefits section
  "No Risk, No Catches": "Sin Riesgo, Sin Trampas",
  "100% FREE — forever": "100% GRATIS — para siempre",
  "Zero credit card required": "Cero tarjeta de crédito requerida",
  "Upgrade only if you want more power": "Actualiza solo si quieres más poder"
};
